import type { Category } from "../Category.js";
import type { Product } from "../Product.js";
import { categoryProductTypeMap, productTypeSlugMap } from "../ProductType.js";
import { productsPathMap } from "./productsPathMap.js";

export function getProductDetailPath(category: Category, product: Pick<Product, "locale" | "urlSlug">): string {
	const productType = categoryProductTypeMap[category];
	return `${productsPathMap[product.locale]}/${productTypeSlugMap[productType][product.locale]}/${product.urlSlug}`;
}
